<template>
  <RouterView />
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
const route = useRoute()
const params: any = new URLSearchParams(window.location.search);
console.log("params", params.get('zone'))

if (params.get('zone')) {
  localStorage.setItem('lang', params.get('zone'))
}

const { locale } = useI18n()
// 初始化时从 localStorage 读取用户偏好
const savedLocale = localStorage.getItem('lang')
if (savedLocale) {
  locale.value = savedLocale
}

</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1ca692;
  height: 100%;
  background-color: #1ca692;
}
</style>
